import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const All = () => {
  return <ObsIframe path="/tasklist/all-task" />;
};

export default React.memo(All);
